<template>
  <div class="router-wrap">
    <el-container style="height:100%;">
      <el-header style="height: auto; padding: 0">
        <Head></Head>
        <!-- <Menu></Menu> -->
        <!-- <Banner v-if="isHome"></Banner> -->
      </el-header>
      <el-main>
        <router-view />
      </el-main>
      <el-footer>
        <Footer></Footer>
      </el-footer>
    </el-container>
  </div>
</template>

<script>
import Menu from '../layout/menu'
import Head from '../layout/head'
import Banner from '../layout/banner'
import Footer from '../layout/footer'
export default {
  name: 'Home',
  data () {
    return {
      loginForm: {
        userName: '',
        password: ''
      },
      rules: {
        userName: []
      }
    }
  },
  components: {
    Menu,
    Head,
    Banner,
    Footer
  },
  computed: {
    isHome () {
      return this.$route.name === 'home'
    }
  },
  mounted () {
    // console.log(login, 'login')
    // this.postlogin()
  },
  methods: {
    postlogin () {
      login().then(() => {})
    },
    getlogin () {
      login1.then(() => {})
    }
  }
}
</script>

<style lang="scss" scoped>
.bottomc {
  height: calc(100% - 56px);
}
.router-wrap {
  height: auto;
  background:$color-greybg;
}
.aside {
  width: auto !important;
}
.noheight {
  display: none;
}
.el-header{
  background: #fff;
}
.el-footer {
  padding:0;
}
.el-main{
padding: 0;
overflow: hidden;
height: auto;
min-height: 90vh;
margin: 0 auto;
width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/officalweb/index.vue